export enum ContexteModificationEnum {
  ADRESSE = 'adresse',
  COURRIEL = 'courriel',
  TELEPHONE = 'telephone',
}
